// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"OrderRatingDialog_contentContainer__27bCu"};